import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Typography, Box } from '@mui/material';
import mockData from './mockData.json';
import CurrencyTable from './CurrencyTable';
import NewsList from './NewsList';
import Navbar from './Navbar';

export default function NewsPage() {
  const { hotCoins, topGainers, topLosers } = mockData;
  const [cryptoNews, setCryptoNews] = useState([]);

  const fetchCryptoNews = async () => {
    const response = await axios.get('https://api.coingecko.com/api/v3/news');
    setCryptoNews(response.data.data);
  };

  useEffect(() => {
    fetchCryptoNews().catch((error) => {
      console.error(error);
    });
  }, []);

  return (
    <div>
    <Container maxWidth="xl" sx={{
      height: '100vh',
      maxWidth: '100%',
      padding: '0',
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      background: 'linear-gradient(to bottom, #87CEEB, #FFFFFF)',      
      
    }}>
      <Typography variant="h6" align="center" sx={{ marginTop: '20px', marginBottom: '5px', color: 'darkslateblue' }}> 
        Crypto News
      </Typography>
      <Box sx={{ flexGrow: 1, padding: '20px' }}>  
        <NewsList cryptoNews={cryptoNews} />
      </Box>
      <Typography variant="h6" align="center" sx={{ marginTop: '5px', marginBottom: '20px', color: 'darkslateblue' }}> 
        Rankings
      </Typography>
      <Box display="flex" justifyContent="space-around" flexDirection={{ xs: 'column', md: 'row' }} gap={{ xs: 2, md: 3 }}>
        <CurrencyTable title="Hot Coins" currencies={hotCoins} />
        <CurrencyTable title="Top Gainers" currencies={topGainers} />
        <CurrencyTable title="Top Losers" currencies={topLosers} />
      </Box>
    </Container>
    <Navbar/>
    </div>
  );
}
